
import therapist from "../../assets/images/adminHome/Therapist.svg"
import user from "../../assets/images/adminHome/User.svg"
import sessions from "../../assets/images/adminHome/Sessions.svg";
import income from "../../assets/images/adminHome/Income.svg";

const OverviewData = [
  {
    id: 1,
    title: "Total Therapist",
    image: therapist,
    description: 0,
    key: "totalTherapistCount",
  },
  {
    id: 2,
    title: "Total User",
    image: user,
    description: 0,
    key: "totalUserCount",
  },
  {
    id: 3,
    title: "Total Sessions",
    image: sessions,
    description: 0,
    key: "totalSessions",
  },
  {
    id: 4,
    title: "Monthly Income",
    image: income,
    description: 0,
    key: "monthlyIncome",
  },
];

export default OverviewData;
